import { useState } from 'react';
import { Modal, Form, Input, DatePicker, Button, Space, message } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useAuth } from '../../context/AuthContext';
import { useApi } from '../../hooks/use_api';

function ScheduleHangoutModal({ open, onCancel, onSuccess, entityId }) {
    const { user } = useAuth();
    const api = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const values = await form.validateFields();
        setLoading(true);
        try {
            await api.post(`/api/entities/${entityId}/schedule-hangout`, {
                scheduled_at: values.scheduled_at.toISOString(),
                title: values.title || undefined,
                user_id: user?.id,
            });
            message.success('Hangout scheduled');
            form.resetFields();
            onSuccess?.();
        } catch (err) {
            message.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={<Space><CalendarOutlined />Schedule a Hangout</Space>}
            open={open}
            onCancel={() => { form.resetFields(); onCancel(); }}
            footer={
                <Space>
                    <Button onClick={() => { form.resetFields(); onCancel(); }}>Cancel</Button>
                    <Button type="primary" loading={loading} onClick={handleSubmit}>Schedule</Button>
                </Space>
            }
            width={420}
        >
            <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
                <Form.Item
                    label="Date & Time"
                    name="scheduled_at"
                    rules={[{ required: true, message: 'Pick a date and time' }]}
                >
                    <DatePicker
                        showTime={{ format: 'HH:mm', minuteStep: 15 }}
                        format="D MMM YYYY HH:mm"
                        disabledDate={d => d && d < dayjs().startOf('day')}
                        style={{ width: '100%' }}
                        placeholder="Select date and time"
                    />
                </Form.Item>
                <Form.Item label="Title (optional)" name="title">
                    <Input placeholder="e.g. Weekly sync" maxLength={80} />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ScheduleHangoutModal;
